import { Divider } from "@aws-amplify/ui-react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useUpdate } from "@refinedev/core";

interface UnlockInvestmentConfirmationModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  date: string;
  onSuccess: () => void;
}

export const UnlockInvestmentConfirmationModal: React.FC<
  UnlockInvestmentConfirmationModalProps
> = ({ open, setOpen, date, onSuccess }) => {
  const { mutate, isLoading } = useUpdate();

  const handleUnlock = () => {
    mutate(
      {
        resource: "investments-history-unlock",
        values: { date: date },
        id: "",
      },
      {
        onSuccess: () => {
          setOpen(false);
          onSuccess();
        },
      }
    );
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Unlock Investment History</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText>
          {`Are you sure you want to unlock the investment history for ${date}? This will allow editing of market prices for this date.`}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={isLoading}
          startIcon={
            isLoading && <CircularProgress size={20} color="inherit" />
          }
          onClick={handleUnlock}
          variant="contained"
          color="primary"
        >
          Confirm
        </Button>
        <Button onClick={() => setOpen(false)} variant="outlined">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

